import React from 'react';
import { ThemeProvider } from 'styled-components';
import MainTheme from './DefaultTheme.js';
import { GlobalStyles } from './GlobalStyles.js';
var HelixTheme = React.createContext({});

var HelixThemeProvider = function HelixThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? MainTheme : _ref$theme,
      children = _ref.children;
  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(React.Fragment, null, React.createElement(GlobalStyles, null), children));
};

HelixTheme.Consumer;
export { HelixTheme, HelixThemeProvider };